import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../Button";
import { classNames } from "../../Utils";

const EmptyState = ({
  titleKey,
  descriptionKey,
  buttonTitle,
  onClick,
  children,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(className ? className : "max-w-lg")}>
      <div className="bg-white shadow rounded-lg">
        <div className="flex flex-col px-4 py-5 sm:p-6 gap-6">
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              {t(titleKey)}
            </h3>
            <div className="mt-2 sm:flex sm:items-start sm:justify-between">
              <div className="max-w-xl text-sm text-gray-500">
                <p>{t(descriptionKey)}</p>
              </div>
              {buttonTitle && onClick && (
                <div className="mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center">
                  <Button
                    data-testid="no-business-profile"
                    onClick={onClick}
                    type="button"
                    color="primary"
                    title={t(buttonTitle)}
                  />
                </div>
              )}
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
